import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "trackerdaily_pwa_dismissed_at";
const DISMISS_MS = 1000 * 60 * 60 * 24 * 7; // 7 days

export default function InstallPWAButton() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissedAt = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (dismissedAt && Date.now() - dismissedAt < DISMISS_MS) return;

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);

    const onInstalled = () => setVisible(false);
    window.addEventListener("appinstalled", onInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!visible || !deferred) return null;

  const install = async () => {
    deferred.prompt();
    try {
      await deferred.userChoice;
    } catch {}
    setVisible(false);
    setDeferred(null);
  };

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-20 md:bottom-6 left-4 right-4 md:left-auto md:right-6 md:w-96 z-40 rounded-xl bg-brand-primary text-brand-bg shadow-2xl px-4 py-3 flex items-center gap-3 animate-fade-up"
      data-testid="install-pwa-banner"
    >
      <div className="h-10 w-10 rounded-md bg-brand-bg/10 flex items-center justify-center flex-shrink-0">
        <Download className="h-5 w-5" strokeWidth={1.75} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-display font-bold">Install Tracker Daily</div>
        <div className="text-xs opacity-80">Add to your home screen for one-tap access.</div>
      </div>
      <Button
        onClick={install}
        size="sm"
        data-testid="install-pwa-btn"
        className="bg-brand-bg text-brand-primary hover:bg-brand-hover"
      >
        Install
      </Button>
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        data-testid="install-pwa-dismiss"
        className="p-1 opacity-70 hover:opacity-100"
      >
        <X className="h-4 w-4" strokeWidth={1.75} />
      </button>
    </div>
  );
}
